import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  agrexAddressCode: attr('string'),
  kanji: attr('string'),
  kana: attr('string'),
  postalCode: attr('string'),
  type: attr('string')
}).reopenClass({
  _modelNameForMigration: 'jp-town'
});